import { useCallback } from 'react';
import { useThrottledCallback } from 'use-debounce';

import { getInstanceIdFromDocumentDomElement, searchForVariationElement } from 'src/data/document';
import { useDocumentActions } from '../../store';

const HOVER_CHECK_INTERVAL = 100;

export const useHandlers = () => {
  const documentActions = useDocumentActions();

  const storeHoveredVariation = useThrottledCallback((target) => {
    if (!target) {
      documentActions.activateVariation(null);
    }

    const variationElement = searchForVariationElement(target);
    if (variationElement) {
      const instanceId = getInstanceIdFromDocumentDomElement(variationElement);
      documentActions.activateVariation(instanceId);
    } else {
      documentActions.activateVariation(null);
    }
  }, HOVER_CHECK_INTERVAL);

  const handleEditableMouseMove = useCallback(
    (event) => {
      event.persist();
      storeHoveredVariation(event.target);
    },
    [storeHoveredVariation]
  );

  const handleEditableMouseLeave = useCallback(() => {
    storeHoveredVariation(null);
  }, [storeHoveredVariation]);

  return {
    handleEditableMouseMove,
    handleEditableMouseLeave,
  };
};
